import { inject } from '@angular/core';
import { catchError, of, switchMap } from 'rxjs';
import { AuthService } from './auth.service';
import { injectGuardDenials } from './guard-denials';

export function permissionGuard(requiredPermission: string) {
  return () => {
    const authService = inject(AuthService);
    const deny = injectGuardDenials();

    return authService.authenticate().pipe(
      switchMap((isAuthenticated) => {
        if (!isAuthenticated) {
          return of(false);
        }
        return authService.ensureUserAccessLoaded$().pipe(
          switchMap(() =>
            authService.hasPermission(requiredPermission) ? of(true) : deny.noPermission$()
          ),
          catchError((error: unknown) => deny.accountLoadFailed$(error))
        );
      })
    );
  };
}
